import { useContext } from 'react'
import { EnterpriseContext } from '../EnterpriseContext'

export const useLogger = () => {
  const { logger } = useContext(EnterpriseContext)

  return logger
}
